import React from 'react';

const Blog = () => {
    return (
        <div>
            log
        </div>
    );
};

export default Blog;